export default __webpack_public_path__ + "static/tabsSectionBg-552f2891721b6676396a54357c6f2878.png";